module.exports = __webpack_public_path__ + "static/media/receive.38c6eeb2.svg";